import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { take, shareReplay, finalize } from "rxjs/operators";

@Injectable()
export class ApiService{
    private _activeRequests = new Map<string, Observable<any>>();

    constructor(
        private _http: HttpClient,
    ){}

    get(path: string, params?: HttpParams): Observable<any>{
        const options = {
            params: params || new HttpParams(),
            headers: {
                'Cache-control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache'
            }
        };
        if(!params && this._activeRequests.has(path)){
            console.log('reusing in-progress GET request: ', path);
            return this._activeRequests.get(path);
        }

        const obs = this._http.get(`/api${path}`, options).pipe(
            take(1),
            shareReplay(),
            finalize(() => {
                this._activeRequests.delete(path);
            }));
        return obs;
    }

    post(path: string, body: object = {}): Observable<any>{
        console.log('posting data', path, body)
        return this._http.post(`/api${path}`, JSON.stringify(body)).pipe(take(1), shareReplay());
    }
}


// WEBPACK FOOTER //
// ./src/app/Services/api.service.ts